// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".inxmail .icheck-label{max-width:calc(100% - 30px)}.inxmail .topics-title{padding-bottom:3px;margin-bottom:.2em}.inxmail .topics-wrapper{width:100%}.inxmail .scfDropListGeneralPanel{margin-bottom:0}.inxmail .scfCheckBoxListGeneralPanel{padding-top:3px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
